//-------------------------------------------
// start register
//-------------------------------------------
$(document).ready(function(){
    $(".toggle-password").click(function() {
        $(this).toggleClass("field-icon--on");
        var input = $($(this).attr("toggle"));
        if (input.attr("type") == "password") {
        input.attr("type", "text");
        } else {
        input.attr("type", "password");
        }
    });

    // Prevent unsafe characters in person name fields while typing.
    // Allowed: letters (incl. accents), spaces, apostrophe, dot and hyphen.
    $(document).on('input', 'input[name="name"], input[name="last_name"], input[name="last_name_2"]', function () {
        var cleaned = (this.value || '').replace(/[^A-Za-zÀ-ÖØ-öø-ÿ' .-]/g, '');
        if (cleaned !== this.value) {
            this.value = cleaned;
        }
    });

    // Soft-block HTML tag chars in other free-text fields.
    $(document).on('input', 'input[name="workplace"], input[name="city_name"], input[name="id_card"], input[name="college_number"], input[name="mobile_phone"]', function () {
        var cleaned = (this.value || '').replace(/[<>]/g, '');
        if (cleaned !== this.value) {
            this.value = cleaned;
        }
    });
});

$(document).ready(function(){
  $('[name="province_id"]').change(function(){
      $.post($(this).data('ajax_url'), { 'province_id':$(this).val(), '_token': $('form input[name="_token"]').val() }, function( data ) {
          $("[name='city_id']").html('');
          $("[name='city_id']").append('<option value="" selected></option>');
          for(var i=0;i<data.length;i++) {
              $("[name='city_id']").append('<option value='+ data[i].id +'>'+data[i].name+ '</option>');
          }

      });
  });
});

// register form now submits normally (controller handles redirect)

//-------------------------------------------
// end register
//-------------------------------------------

//-------------------------------------------
// start login
//-------------------------------------------
$("#login_form").on("submit", function (e) {

    e.preventDefault();
    $form = $(this);
    $btn = $form.find('[type="submit"]');
    $btn.prop("disabled", true);
    formData = $form.serialize();

    $.post($form.data('action'), formData, function( response ) {
        if (response.success == 1) {
            window.location.href = $form.data('redirect_to');
        } else {
            showFeedback(response.message, 'warning');
        }
    })
    .fail(function(error) {
        if (error.status == 422) {
            var data = error.responseJSON;
            showFeedback(data.message, 'danger', false, data.errors);
        } else {
            showFeedback($form.data('error_text'), 'danger');
        }
    })
    .always(function() {
        $btn.prop("disabled", false);
    })

})
//-------------------------------------------
// end login
//-------------------------------------------

//-------------------------------------------
// start register gate
//-------------------------------------------
$("#register_gate_form").on("submit", function (e) {
    e.preventDefault();

    var $form = $(this);
    var $btn = $form.find('[type="submit"]');
    var $feedback = $("#register_gate_feedback");
    $btn.prop("disabled", true);
    $feedback.html('');

    $.post($form.data('action'), $form.serialize(), function (response) {
        if (response.success == 1 && response.redirect_url) {
            window.location.href = response.redirect_url;
            return;
        }
        showRegisterGateFeedback(response.message, 'warning');
    })
    .fail(function(error) {
        if (error.status == 422) {
            var data = error.responseJSON;
            showRegisterGateFeedback(data.message, 'danger', data.errors);
        } else if (error.responseJSON && error.responseJSON.message) {
            showRegisterGateFeedback(error.responseJSON.message, 'danger');
        } else {
            showRegisterGateFeedback($form.data('error_text'), 'danger');
        }
    })
    .always(function() {
        $btn.prop("disabled", false);
    });
});
//-------------------------------------------
// end register gate
//-------------------------------------------

//-------------------------------------------
// start forgot password
//-------------------------------------------
$("#password_form").on("submit", function (e) {

    console.log("forgot...");

    e.preventDefault();
    $form = $(this);
    $btn = $form.find('[type="submit"]');
    $btn.prop("disabled", true);

    $.post( $form.data('action'),{
        email: $form.find("[name='forgot_password_email']").val(),
        _token: $form.find("[name='_token']").val()
    }, function (response) {


        if(response.success == 1) {
            showFeedback(response.message, 'success');
            $form.trigger('reset');
            $('.js-form-wrapper').hide();

        }else{
            showFeedback(response.message, 'warning');
        }


    })
    .fail(function(error) {
        if (error.status == 422) {
            var data = error.responseJSON;
            showFeedback(data.message, 'danger', false, data.errors);
        } else {
            showFeedback($form.data('error_text'), 'danger');
        }
    })
    .always(function() {
        $btn.prop("disabled", false);
    })
})

//-------------------------------------------
// end forgot password
//-------------------------------------------

//-------------------------------------------
// start reset password
//-------------------------------------------

$(".toggle-passwordone").click(function() {

    $(this).toggleClass(".field-icon--on");
    var input = $($(this).attr("toggle"));
    if (input.attr("type") == "password") {
        input.attr("type", "text");
    } else {
        input.attr("type", "password");
    }
});

$("#pass_form").on("submit", function (e) {

    e.preventDefault();
    $form = $(this);
    $btn = $form.find('[type="submit"]');
    $btn.prop("disabled", true);
    formData = $form.serialize();

    $.post( $form.data('action'), formData, function (response) {
        console.log(response);
        if(response.success == 1) {
            showFeedback(response.message, 'success', false);
            $form.trigger('reset');
            $('.js-form-wrapper').hide();
            $('.js-go_to_login_wrapper').show();
        }else{
            showFeedback(response.message, 'warning', false);
        }
    })
    .fail(function(error) {
        if (error.status == 422) {
            var data = error.responseJSON;
            showFeedback(data.message, 'danger', false, data.errors);
        } else {
            showFeedback($form.data('error_text'), 'danger');
        }
    })
    .always(function() {
        $btn.prop("disabled", false);
    })
})

//-------------------------------------------
// end reset password
//-------------------------------------------

function showFeedback(message, alert_type, expires = false, errors = {}) {
    var feedback = document.querySelector('.js-feedback');
    // Reset feedback content
    feedback.innerHTML = '';

    var container = document.createElement('div');
    container.className = 'alert ' + 'alert-' + alert_type;

    // If errors
    if (Object.keys(errors).length > 0) {
        var errorUl = document.createElement('ul');
        errorUl.style.margin = 0;
        errorUl.style.paddingLeft = "20px";

        Object.values(errors).forEach(function (error, i) {
            error.forEach(function (err) {
                var errorLi = document.createElement('li');
                errorLi.innerText = err;
                errorUl.appendChild(errorLi);
            })
        });

        container.appendChild(errorUl);
    } else {
        var text = document.createElement('div');
        text.innerHTML = message;
        container.appendChild(text);
    }

    // Show feedback
    feedback.appendChild(container);

    if (expires) {
        setTimeout(function() {
            feedback.innerHTML = '';
        }, 6000);
    }
}

function showRegisterGateFeedback(message, alert_type, errors = {}) {
    var feedback = document.getElementById('register_gate_feedback');
    if (!feedback) {
        return;
    }
    feedback.innerHTML = '';

    var container = document.createElement('div');
    container.className = 'alert ' + 'alert-' + alert_type;

    if (Object.keys(errors).length > 0) {
        var errorUl = document.createElement('ul');
        errorUl.style.margin = 0;
        errorUl.style.paddingLeft = "20px";

        Object.values(errors).forEach(function (error) {
            error.forEach(function (err) {
                var errorLi = document.createElement('li');
                errorLi.innerText = err;
                errorUl.appendChild(errorLi);
            })
        });

        container.appendChild(errorUl);
    } else {
        var text = document.createElement('div');
        text.innerHTML = message;
        container.appendChild(text);
    }

    feedback.appendChild(container);
}
